import { SupportedLanguages } from '@/i18n/config'

export const toSupportedLanguage = (
  language: string | undefined,
): SupportedLanguages => {
  switch (language) {
    case 'ja':
      return SupportedLanguages.ja
    case 'en':
      return SupportedLanguages.enUS
    case 'zh':
    default:
      return SupportedLanguages.zhTW
  }
}
